export var EnumAccountStatus;
(function (EnumAccountStatus) {
    EnumAccountStatus["Created"] = "created";
    EnumAccountStatus["Approved"] = "approved";
    EnumAccountStatus["Banned"] = "banned";
    EnumAccountStatus["UnBanned"] = "un_banned";
})(EnumAccountStatus || (EnumAccountStatus = {}));
export var EnumRequestHeaderNames;
(function (EnumRequestHeaderNames) {
    EnumRequestHeaderNames["UserToken"] = "x-access-token";
    EnumRequestHeaderNames["ProfileUUID"] = "x-access-profile-uuid";
    EnumRequestHeaderNames["DomainEnv"] = "x-domain-env";
    EnumRequestHeaderNames["CountryCode"] = "router-country-code";
    EnumRequestHeaderNames["IpAddress"] = "router-ip-address";
})(EnumRequestHeaderNames || (EnumRequestHeaderNames = {}));
export var EnumRequestCookieNames;
(function (EnumRequestCookieNames) {
    EnumRequestCookieNames["Fbc"] = "fbc_value";
})(EnumRequestCookieNames || (EnumRequestCookieNames = {}));
export var EnumGraphQLErrorCode;
(function (EnumGraphQLErrorCode) {
    EnumGraphQLErrorCode["USER_ERROR"] = "USER_ERROR";
    EnumGraphQLErrorCode["APP_ERROR"] = "APP_ERROR";
    EnumGraphQLErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    EnumGraphQLErrorCode["NOT_AUTHENTICATED_ERROR"] = "NOT_AUTHENTICATED_ERROR";
    EnumGraphQLErrorCode["ACCESS_DENIED_ERROR"] = "ACCESS_DENIED_ERROR";
    EnumGraphQLErrorCode["NOT_FOUND_ERROR"] = "NOT_FOUND_ERROR";
    EnumGraphQLErrorCode["NOT_ALLOWED_ERROR"] = "NOT_ALLOWED_ERROR";
    EnumGraphQLErrorCode["UNCLASSIFIED_ERROR"] = "UNCLASSIFIED_ERROR";
})(EnumGraphQLErrorCode || (EnumGraphQLErrorCode = {}));
export var EnumImageMimeTypes;
(function (EnumImageMimeTypes) {
    EnumImageMimeTypes["gif"] = "image/gif";
    EnumImageMimeTypes["jpeg"] = "image/jpeg";
    EnumImageMimeTypes["png"] = "image/png";
    EnumImageMimeTypes["svg"] = "image/svg+xml";
    EnumImageMimeTypes["webp"] = "image/webp";
})(EnumImageMimeTypes || (EnumImageMimeTypes = {}));
export var EnumVideoMimeTypes;
(function (EnumVideoMimeTypes) {
    EnumVideoMimeTypes["avi"] = "video/x-msvideo";
    EnumVideoMimeTypes["mp4"] = "video/mp4";
    EnumVideoMimeTypes["mpeg"] = "video/mpeg";
    EnumVideoMimeTypes["webm"] = "video/webm";
    EnumVideoMimeTypes["mov"] = "video/quicktime";
})(EnumVideoMimeTypes || (EnumVideoMimeTypes = {}));
export var EnumSCEntitlementLookupKey;
(function (EnumSCEntitlementLookupKey) {
    EnumSCEntitlementLookupKey["ai_comment_replies"] = "ai_comment_replies";
    EnumSCEntitlementLookupKey["connect_1_social"] = "connect_1_social";
    EnumSCEntitlementLookupKey["connect_5_social"] = "connect_5_social";
    EnumSCEntitlementLookupKey["generate_1_reply"] = "1_generated_reply";
    EnumSCEntitlementLookupKey["generate_2_replies"] = "2_generated_replies";
    EnumSCEntitlementLookupKey["generate_5_replies"] = "5_generated_replies";
    EnumSCEntitlementLookupKey["max_replies_day_10"] = "10_replies_day";
    EnumSCEntitlementLookupKey["max_replies_day_50"] = "50_replies_day";
    EnumSCEntitlementLookupKey["max_replies_day_500"] = "500_replies_day";
    EnumSCEntitlementLookupKey["max_workflows_10"] = "max_workflows_10";
    EnumSCEntitlementLookupKey["max_workflows_50"] = "max_workflows_50";
    EnumSCEntitlementLookupKey["reply_via_dm"] = "reply_via_dm";
    EnumSCEntitlementLookupKey["business_level_workflow"] = "business_workflow";
    EnumSCEntitlementLookupKey["post_level_workflow"] = "post_workflow";
})(EnumSCEntitlementLookupKey || (EnumSCEntitlementLookupKey = {}));
//# sourceMappingURL=interfaces.js.map